import script from "./VersionHistoryModal.vue?vue&type=script&setup=true&lang=js"
export * from "./VersionHistoryModal.vue?vue&type=script&setup=true&lang=js"

import "./VersionHistoryModal.vue?vue&type=style&index=0&id=5209d17f&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5209d17f"]])

export default __exports__